import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  Card,
  Box,
  InputLabel,
  FormControl,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import "../../Styles/uploadFiles.css";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
import BackupIcon from "@mui/icons-material/Backup";
import { makeStyles } from "@mui/styles";
import Stack from "@mui/material/Stack";
import { ButtonSubmitProgress } from "../../components/form/Buttons";
import { postNewQuestion } from "../../Store/Ducks/Question/duckQuestion";
import { getHelpRequestPostGet } from "../../Store/Ducks/masterData/duckMasterData";
import { useDispatch, } from "react-redux";
import { objectToFormData } from '../../Utils/formUtils.js'
import {useHistory} from 'react-router-dom'
import { useSnackbar } from "notistack";
import {snackAction} from '../../components/CustomSnakbar.jsx'
import { useParams} from "react-router-dom";
import {ROUTES} from '../../constants'
const validationSchema = yup.object({
  email: yup
    .string("Enter email ")
    .email("Enter a valid email")
    .required("Email is required"),
  subject: yup
    .string("Enter a subject")
    .min(20, "Subject should be of minimum 20 characters length")
    .required("Subject is required"),
  category: yup.number().required("Category is required"),
  invoiceNumber: yup.string("Enter Invoice number")
    .matches("^[0-9]{0,10}$", "Invoice number should be of minimum 10 characters length, numbers only.")
    .when("category",(category)=>{  
    if(category ===1 || category ===2)
    return yup.string("Enter Invoice number")
    .matches("^[0-9]{0,10}$", "Invoice number should be of minimum 10 characters length, numbers only.")
    .required("Invoice number is required")
  })

});


const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: "10px",
    marginBottom: "10px",
  },
}));
export const ContactForm = ({ email }) => {
  let { category } = useParams();
  const [selectedFiles, setFiles] = useState([]);
  const dispatch = useDispatch();
  const categories = useSelector((store) => store.masterData.categories);
  const societies = useSelector((store) => store.societies.data.filter(x=>x.selected));

  const [onSubmit, setOnSubmit] = useState(false)
  const onDrop = (cfiles) => {
    if (cfiles.length > 0) {
      setFiles(cfiles);
    }
  };
  const history = useHistory();
  useEffect(() => {
    dispatch(getHelpRequestPostGet())
  }, [dispatch])
  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();
  const [selectedCategory, setSelectedCategory] = useState(category);
  const [selectedSociety, setSelectedSociety] = useState(1);
  const categoryRequiredInvoiceNumbre = categories && categories.length > 0 ? categories.filter(x=> x.requiresInvoiceNumber).map((x) => x.id): [];
 

  const formik = useFormik({
    initialValues: {
        email:email,
        subject: "",
        category: category,
        society:selectedSociety,
        detail: '',
        supplierTaxId:'',
        invoiceNumber: '',
  },
    validationSchema: validationSchema,

    onSubmit: (values,{resetForm}) => {
      setOnSubmit(true)
      let formData = objectToFormData(values);
      for (let i = 0; i < selectedFiles.length; i++) {
        const element = selectedFiles[i];
        formData.append("attachments", element)
      }

       dispatch(postNewQuestion(formData)).then(res =>{
       enqueueSnackbar(`Se ha cargado su consulta correctamente`, { variant: "success", action: snackAction, autoHideDuration: null });
        history.push(ROUTES.HOME);
        setOnSubmit(false)
      } )
        .catch(err =>{
          console.dir(err)
          enqueueSnackbar(err.message, { variant: "error", action: snackAction, autoHideDuration: null });
          resetForm();
          setOnSubmit(false)
        } ); 
    },
  });


  const variantEmail = email && email !== "" ? "filled" : "standard";

  const handleClickCancel=()=>{
    history.push(ROUTES.HOME);
  }
  useEffect(() => {
    if(societies && societies.length === 0){
      enqueueSnackbar("Debe seleccionar un país", { variant: "warning", action: snackAction, autoHideDuration: null });
      history.push(ROUTES.SELECT_COUNTRY)
    }
  }, [enqueueSnackbar, history, societies])
  return (
    <div style={{ width: "100%" }}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100%"
      >
        <Card style={{ height: "100%", width:"800px", padding: "10px 50px 10px 50px" }}>
          <form >
            <TextField
              margin="dense"
              variant={variantEmail}
              color="success"
              focused
              fullWidth
              id="email"
              name="email"
              inputProps={{ readOnly: "readonly" }}
              label="Usuario Final"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={
                formik.touched.email && Boolean(formik.errors.email)
              }
              helperText={formik.touched.email && formik.errors.email}
            />
            <FormControl
              color="success"
              //
              sx={{  width:"100%" }}
              className={classes.formControl}
            >
              <InputLabel
                style={{
                  transformOrigin: "  left bottom ",
                  marginBottom: "5px",
                }}
                id="demo-simple-select-helper-label"
              >
                Sociedad TEIC
              </InputLabel>

              <Select
                id="society"
                name="society"
                variant="standard"
                color="success"
                margin="dense"
             
                value={formik.values.society}
                onChange={(e) => {
                  e.preventDefault()
                  setSelectedSociety(e.target.value)
                  formik.handleChange(e);
                }}
                error={
                  formik.touched.society && Boolean(formik.errors.society)
                }
              >
                <MenuItem key={0} value="0">
                  <em>Seleccione...</em>
                </MenuItem>
                {societies.map((soc) => (
                  <MenuItem key={soc.id} value={soc.id}>
                    <em>{soc.code} - {soc.description}</em>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              id="supplierTaxId"
              name="supplierTaxId"
              variant="standard"
              color="success"
              margin="dense"
              label="ID Tributario de Proveedor (CUIT, RUT, RFC)"
              className={classes.formControl}
              value={formik.values.supplierTaxId}
              onChange={formik.handleChange}
              error={formik.touched.supplierTaxId && Boolean(formik.errors.supplierTaxId)}
              helperText={formik.touched.supplierTaxId && formik.errors.supplierTaxId}
            />
            <FormControl
              color="success"
              //
              sx={{  width:"100%" }}
              className={classes.formControl}
            >
              <InputLabel
                style={{
                  transformOrigin: "  left bottom ",
                  marginBottom: "5px",
                }}
                id="demo-simple-select-helper-label"
              >
                Categoria
              </InputLabel>

              <Select
                id="category"
                name="category"
                variant="standard"
                color="success"
                margin="dense"
                labelId="demo-simple-select-helper-label"
                value={formik.values.category}
                // onChange={formik.handleChange}
                onChange={(e) => {
                  e.preventDefault()
                  setSelectedCategory(e.target.value)
                  formik.handleChange(e);
                }}
                error={
                  formik.touched.category && Boolean(formik.errors.category)
                }
              >
                <MenuItem key={0} value="0">
                  <em>Seleccione...</em>
                </MenuItem>
                {categories.map((cate) => (
                  <MenuItem key={cate.id} value={cate.id}>
                    <em>{cate.description}</em>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {categoryRequiredInvoiceNumbre.includes(selectedCategory) &&
              (<TextField
                fullWidth
                id="invoiceNumber"
                name="invoiceNumber"
                variant="standard"
                color="success"
                margin="dense"
                label="Nro. Factura "
                className={classes.formControl}
                value={formik.values.invoiceNumber}
                onChange={formik.handleChange}
                error={formik.touched.invoiceNumber && Boolean(formik.errors.invoiceNumber)}
                helperText={formik.touched.invoiceNumber && formik.errors.invoiceNumber}
              />)
            }

            <TextField
              fullWidth
              id="subject"
              name="subject"
              variant="standard"
              color="success"
              margin="dense"
              label="Asunto"
              className={classes.formControl}
              value={formik.values.subject}
              onChange={formik.handleChange}
              error={formik.touched.subject && Boolean(formik.errors.subject)}
              helperText={formik.touched.subject && formik.errors.subject}
            />
           

            <TextField
              id="detail"
              name="detail"
              label="Detalle"
              multiline
              margin="dense"
              rows={6}
              fullWidth
              className={classes.formControl}
              color="success"
              variant="standard"
              value={formik.values.detail}
              onChange={formik.handleChange}
              error={formik.touched.detail && Boolean(formik.errors.detail)}
              helperText={formik.touched.detail && formik.errors.detail}
            />

            {/* ZONA DE FILES */}
            <div /* className="my-3" */ className={classes.formControl}>
              <Dropzone onDrop={onDrop}>
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps({ className: "dropzone" })}>
                      <input {...getInputProps()} />
                      {selectedFiles &&
                        Array.isArray(selectedFiles) &&
                        selectedFiles.length ? (
                        <div className="selected-file">
                          {selectedFiles.length > 3
                            ? `${selectedFiles.length} files`
                            : selectedFiles.map((file) => file.name).join(", ")}
                        </div>
                      ) : (
                        <>
                          <BackupIcon />
                          <p>
                            Arrastra los archivos aquí o <u> explora</u>
                          </p>
                        </>
                      )}
                    </div>
                    <aside className="selected-file-wrapper"></aside>
                  </section>
                )}
              </Dropzone>
            </div>

            {/*FIN ZONA DE FILES  */}
            <div style={{ marginTop: 4, alignContent: "end" }}>
              <Grid container >
                <Grid item xs={6}>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="flex-start"
                    
                  >
                    <Button style={{ marginRight: 0 }} color="error" variant="outlined"
                      onClick={(e) => {
                        e.preventDefault()
                        setFiles([])
                        formik.resetForm(e)
                      }}
                    >
                      Limpiar
                    </Button>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="flex-end"
                
                  >
                    <Button color="error" onClick={handleClickCancel} variant="outlined">
                      Cancelar
                    </Button>
                 
                    <ButtonSubmitProgress color="primary" loading={onSubmit} variant="contained" onClick={formik.handleSubmit}>
                      Enviar
                    </ButtonSubmitProgress>
                  </Stack>
                </Grid>
              </Grid>
            </div>
          </form>
        </Card>
      </Box>
    </div>
  );
};
